import { PurchasingDocument } from './purchasing-document'
import { PurchasingInvoiceLineItem } from './purchasing-invoice-line-item'

export class PurchasingInvoice {
    id!: string
    purchaseOrderId!: string | undefined
    invoiceNumber!: string
    vendor!: number | undefined
    vendorName!: string
    invoiceDate!: Date | undefined
    dueDate!: Date | undefined
    status!: string
    subtotal!: number | undefined
    taxAmount!: number | undefined
    freightAmount!: number | undefined
    total!: number | undefined
    source!: string
    sourceMessageId!: string
    sourceAttachmentId!: string
    sourceEmailSubject!: string
    sourceReceivedOn!: Date | undefined
    notes!: string
    createdOn!: Date | undefined
    archived!: boolean

    lineItems: PurchasingInvoiceLineItem[] = []
    documents: PurchasingDocument[] = []
    poNumber!: string
    job!: string
    equipment!: string
    workOrder!: string
    isMatched!: boolean
    receiptCount!: number
}
